import { authHeader } from '../_helpers';
import { handleResponse } from '../_helpers';
import { apiClient } from '../_helpers';

export const operatorService = {
  getAll,
  getSelectList,
  searchOperators,
  getById,
  addOperator,
  updateOperator,
  deleteOperator
};

function getAll(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  var ps = "";
  var ccat = "";
  if(params && params.query)
  {
    ps = ps + "searchQuery=" + params.query;
    ccat = "&";
  }
  if(params && params.filter)
  { 
    ps = ps + ccat + "filter=" + params.filter;
    ccat = "&";
  }
  if(params && params.pageSize)
  { 
    ps = ps + ccat + "pageSize=" + params.pageSize;
    ccat = "&";
  }
  if(params && params.page)
  {
    ps = ps + ccat + "pageNumber=" + params.page;
    ccat = "&";
  }
  if(params && params.dataTypes)
  {
    for (var i = 0; i < params.dataTypes.length; i++) { 
      ps = ps + ccat + "dataTypes=" + params.dataTypes[i];
      ccat = "&";
    }
  }

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/operators?${ps}`, requestOptions).then(handleResponse);
}

function getSelectList() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/operators/selectlist`, requestOptions).then(handleResponse);
}

function searchOperators(qry) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/operators?searchQuery=${qry}`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/operators/${id}`, requestOptions).then(handleResponse);
}
function addOperator(newOperator) {
  return apiClient('operators/')
  .post('',`${JSON.stringify(newOperator)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function updateOperator(operator) {
  return apiClient(`operators/${operator.id}`)
  .put('',`${JSON.stringify(operator)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function deleteOperator(operator) {
  return apiClient(`operators/${operator}`)
  .delete()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}